module.exports = __webpack_public_path__ + "web/img/z31.b4aea02f.png";